import React, { useEffect, useState } from 'react';
import api from '../services/api';
import './TvIpialesEmbed.css';

/**
 * Página solo para embed: sin header ni footer.
 * Muestra el stream de TV Ipiales a pantalla completa.
 * La URL del reproductor se puede configurar en admin (clave: tv_ipiales_embed_url).
 * Fallback: widget oficial de TV Ipiales (asilivehd).
 */
const DEFAULT_STREAM_URL = process.env.REACT_APP_TV_IPIALES_EMBED_URL || 'https://server.asilivehd.com/hybrid-stream-video-widget/tvipiales';

const TvIpialesEmbed = () => {
  const [streamUrl, setStreamUrl] = useState(DEFAULT_STREAM_URL);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const requestFullscreen = () => {
    const el = document.documentElement;
    if (!el.requestFullscreen) return;
    el.requestFullscreen().catch(() => {});
  };

  useEffect(() => {
    let cancelled = false;
    api.get('/configuracion/tv_ipiales_embed_url')
      .then((res) => {
        if (cancelled) return;
        const url = res.data?.valor?.trim();
        if (url) setStreamUrl(url);
      })
      .catch(() => {
        if (!cancelled) setStreamUrl(DEFAULT_STREAM_URL);
      });
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <div className="tv-embed-page">
        <div className="tv-embed-loading">
          <span className="tv-embed-spinner" />
          <p>Cargando transmisión en vivo…</p>
        </div>
      </div>
    );
  }

  if (error || !streamUrl) {
    return (
      <div className="tv-embed-page">
        <div className="tv-embed-placeholder">
          <h2>TV Ipiales en Vivo</h2>
          <p>Transmisión no configurada o no disponible.</p>
          <p className="tv-embed-hint">Configure la URL en Admin → Configuración → &quot;URL del reproductor TV Ipiales en vivo&quot;.</p>
          <a href="/medios" target="_top" rel="noopener noreferrer" className="tv-embed-back">
            Volver a Medios
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="tv-embed-page">
      <iframe
        src={streamUrl}
        title="TV Ipiales en Vivo"
        className="tv-embed-iframe"
        allowFullScreen
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
      />
      <button
        type="button"
        className="tv-embed-fullscreen-btn"
        onClick={requestFullscreen}
        aria-label="Pantalla completa"
        title="Ver en pantalla completa (F11)"
      >
        ⛶ Pantalla completa
      </button>
    </div>
  );
};

export default TvIpialesEmbed;
